export default "__VITE_ASSET__B$mkk6ge__"